var _style, _defs, _rect, _defs2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsmartlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157.9 43",
    style: {
      enableBackground: "new 0 0 157.9 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);} .st1{clip-path:url(#SVGID_5_);fill:#F28B83;} .st2{clip-path:url(#SVGID_5_);fill:#EC967A;} .st3{clip-path:url(#SVGID_5_);fill:#F0C180;} .st4{clip-path:url(#SVGID_5_);fill:#D27C5E;} ")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M35.4,30.7c-0.1-2.2,1.8-2.4,2.1-2.5c2.1-0.6,6,0.1,6,0.1v3.5c0,0-1.8,1.5-4.3,1.6c-0.1,0-0.2,0-0.3,0 C36.6,33.4,35.4,32.8,35.4,30.7 M37.2,19.5c-1,0-3.2,0.6-3.2,0.6v2.2c0,0,2.1-0.5,3.7-0.6c1.6-0.1,3.6-0.3,4.6,0.5 c1,0.8,1.1,1.7,1.1,1.7l0,2c0,0-3.4-0.4-4.7-0.3c-1.2,0.1-2.7,0.1-4,1c-1.6,1-2.2,2.4-2.2,4c0,1.5,0.8,5.9,7.6,4.8 c1.6-0.2,3.6-1.5,3.6-1.5l1.1,1.7h1.5c0,0,0.2-9.6,0-11.8c-0.2-2.2-1.7-3.3-2.4-3.5c-1.7-0.7-3.3-0.9-4.6-0.9 C38.3,19.4,37.6,19.5,37.2,19.5 M100.1,19.3v16.3h4.1V24.2c1-1,2.4-2,3.9-1.6c2.2,0.6,1.8,4,1.8,4v9h4V24.3c1-1,2.7-2.2,4.3-1.7 c2.2,0.6,1.8,4,1.8,4v9h4V24.3c0,0,0-1.8-1-2.9c-0.8-1-1.8-2.4-5.5-1.9c-1.8,0.2-3.4,1.3-4.3,2.1c-0.8-1-1.9-2.5-5.5-2 c-1.8,0.2-3.2,1.4-4,2.2l-0.6-2.4H100.1z M128.8,30.6c0-1.6,1.2-2,1.5-2c2.1-0.6,4.9,0.2,4.9,0.2l0,2.7c0,0-1.2,1.1-3.6,1.3 c-0.1,0-0.3,0-0.4,0C129.5,32.8,128.8,31.6,128.8,30.6 M129.6,19.5c-1,0-3.5,0.7-3.5,0.7l0,3.1c0,0,2.3-0.5,3.9-0.6 c1.6-0.1,2.8-0.4,4,0.2c1.2,0.6,1.1,1.6,1.1,1.6l0.1,1.5c0,0-2.8-0.4-4-0.4c-1.2,0.1-2.7,0.1-4,1c-1.6,1-2.2,1.4-2.4,4 c-0.1,1.5,0.2,5.8,7.6,4.7c1.6-0.2,3-1.3,3-1.3l1.5,1.5h2.4c0,0,0.1-9.6-0.1-11.8c-0.2-2.2-2.3-3.5-3-3.8c-1.4-0.6-2.8-0.8-4-0.8 C131,19.3,130.1,19.5,129.6,19.5 M55.7,33.2c-1,0-2.4-0.4-3.5-0.8V22.1c0,0,1.9-0.4,3.1-0.4c3.4,0,5.8,1,5.8,5.6 C61.2,32.3,58.2,33.2,55.7,33.2C55.8,33.2,55.8,33.2,55.7,33.2 M49.4,20.1v21.4h2.8l-0.1-6.7c0.5,0.2,1,0.4,1.8,0.5 c2.2,0.4,7.4,0.6,9.1-3.5c1.5-3.9,0.9-7.2,0.2-8.7c-0.7-1.5-2-3.3-5.6-3.8c-0.7-0.1-1.4-0.1-2.1-0.1 C52.4,19.3,49.4,20.1,49.4,20.1 M72.5,33.2c-1,0-2.4-0.4-3.6-0.8V22.1c0,0,1.9-0.4,3.1-0.4c3.4,0,5.8,1,5.8,5.6 C78,32.3,75,33.2,72.5,33.2C72.6,33.2,72.6,33.2,72.5,33.2 M66.2,20.1v21.4H69L69,34.8c0.5,0.2,1,0.4,1.8,0.5 c2.2,0.4,7.4,0.6,9.1-3.5c1.5-3.9,0.9-7.2,0.2-8.7c-0.7-1.5-2-3.3-5.6-3.8c-0.7-0.1-1.4-0.1-2.1-0.1 C69.2,19.3,66.2,20.1,66.2,20.1 M91.6,19.3c-4.1,0.4-6.3,1.6-6.1,5.4c0.3,2.9,1.3,3.8,3.3,4.3c0.7,0.2,1.6,0.1,2.6,0.1 c1.9-0.1,3.9-0.2,3.9,1.6c0,2.1-2.5,1.9-4.6,1.9c-2.8-0.4-4.5-1-4.5-1l0.1,3.3c0,0,4.3,1.3,7.7,0.8c2.6-0.4,5.3-1.3,5.2-5.2 c0.1-3.8-2.9-4.4-3.8-4.5c-0.8-0.2-1.8-0.1-2.7-0.1c-1.9,0.1-3.7,0.2-3.5-1.6c0.2-2,3.7-1.9,4.6-1.8c2.2,0.2,4.7,1.1,4.7,1.1 l0-3.2c0,0-2.1-1-5.3-1C92.7,19.2,92.2,19.2,91.6,19.3 M148.9,16.8v2.6c-0.7,0.1-1.9,0.3-3.1,1.2c-0.5,0.3-0.9,0.6-1.2,0.9 l-0.5-2.1h-3.1v16.3h4v-11c0.4-0.4,1.1-1,2.2-1.6c0.5-0.3,1.1-0.4,1.8-0.5v9.3c0,0,0,3.3,2.9,3.7c2.3,0.3,4.9,0.2,4.9,0.2v-3.2 c0,0-2.6,0.4-3.3-0.8c-0.2-0.3-0.4-0.8-0.4-1.9c0-2.3,0-5.8,0-7.3c2,0.1,3.7,0.1,3.7,0.1v-3.4h-4.2l-0.5-2.5H148.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -217.5945,
    y1: 326.8796,
    x2: -216.5945,
    y2: 326.8796,
    gradientTransform: "matrix(124.1212 0 0 -124.1212 27040.6543 40601.8398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAA638"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E84125"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 16.8,
    className: "st0",
    width: 124.1,
    height: 24.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_4_",
    x: 1.6,
    y: 1.4,
    width: 155.1,
    height: 40.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,14.3l-13-2.4c-0.7-0.1-1.2-0.7-1.2-1.4V4.9c0-0.9,0.7-1.6,1.5-1.8l12.7-1.7c0.6-0.1,1.1,0.4,1.1,1v10.8 C17,13.9,16.4,14.4,15.8,14.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.8,27.1l13-2.4c0.7-0.1,1.2-0.7,1.2-1.4v-5.6c0-0.9-0.7-1.6-1.5-1.8L2.8,14.3c-0.6-0.1-1.1,0.4-1.1,1v10.8 C1.6,26.8,2.2,27.2,2.8,27.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26,31.2l-13-2.4c-0.7-0.1-1.2-0.7-1.2-1.4v-5.6c0-0.9,0.7-1.6,1.5-1.8L26,18.3c0.6-0.1,1.1,0.4,1.1,1v10.8 C27.2,30.8,26.6,31.3,26,31.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17,23.3v-3.8L13.3,20c-0.9,0.1-1.5,0.9-1.5,1.8v3.7l4-0.7C16.5,24.6,17,24,17,23.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsmartlogo);
export default __webpack_public_path__ + "static/media/appsmartlogo.3368ddfaa37e7bd31940673c8d896139.svg";
export { ForwardRef as ReactComponent };